import type { StrictOptionType } from '@dh-software/dh-components';
import type { StoreTreeNodeType } from '@dh-software/furnhome-types';

// Die Optionen des Store-Umschalters. Nicht zugeordnete Filialen bleiben sichtbar, aber
// ausgegraut (approved: false) - ihre Unterfilialen koennen trotzdem waehlbar sein.
export function buildStoreOptions(storeTree: Array<StoreTreeNodeType>, activeCustomerNumber: string): Array<StrictOptionType> {
  if (!activeCustomerNumber) {
    return [];
  }

  const storeOptions = mapStoreNodes(storeTree, activeCustomerNumber);

  // Die angemeldete Nummer muss immer drinstehen: ohne ausgewaehlte Option naehme dh-select die
  // erste und zeigte eine Filiale, an der niemand angemeldet ist. Das trifft Mitarbeiter an einer
  // fremden Kundennummer und einen leeren Baum.
  if (!containsCustomerNumber(storeTree, activeCustomerNumber)) {
    storeOptions.unshift({ dataId: activeCustomerNumber, showContent: activeCustomerNumber, selected: true, approved: true, suboptions: [] });
  }

  return storeOptions;
}

function mapStoreNodes(storeNodes: Array<StoreTreeNodeType>, activeCustomerNumber: string): Array<StrictOptionType> {
  return storeNodes.map((storeNode) => ({
    dataId: storeNode.customerNumber,
    showContent: storeNode.customerNumber,
    selected: storeNode.customerNumber === activeCustomerNumber,
    approved: storeNode.granted,
    suboptions: mapStoreNodes(storeNode.subStores, activeCustomerNumber),
  }));
}

function containsCustomerNumber(storeNodes: Array<StoreTreeNodeType>, customerNumber: string): boolean {
  return storeNodes.some((storeNode) => storeNode.customerNumber === customerNumber || containsCustomerNumber(storeNode.subStores, customerNumber));
}
